import type { NavItem } from '@/app/nav/collect'

/**
 * The Candidate menu (My Resume, Applications, Tasks, Documents) is the legacy menu (`navigation/vertical/candidate.js`),
 * declared once by the shell (`src/modules/shell/nav.ts`, ids `ca-*`) and already pointing at this module's paths;
 * the Dashboard entry is WP-18's. The module adds none.
 */
const nav: NavItem[] = []

export default nav
